import { DataModel } from "common/models/utility-models/base-model";

export class StudentAssignmentModel extends DataModel { 

}